<template>

     <div class="px-6 flex justify-between items-center">
        
        <div class="flex-1 flex justify-center items-center  ">
          <p class="text-2xl font-semibold">Admin Menu</p>
        </div>
      </div>
  
      <div  class="pt-8 p-6">

       
        <router-link to="/list-karyawan" class="bg-g300 rounded-2xl p-4 flex-1   flex flex-col justify-center items-center shrink-0"   >          
            <p class=" text-center dark:text-n0 font-large text-white text-center text-sm  ">
              Daftar karyawan
             </p>
         </router-link> 
 

 
      </div>
 

</template>

<script setup>

import { onMounted} from 'vue'
import { useRoute } from 'vue-router'
 



const route = useRoute()
 
 

console.log(route.params.id)

onMounted(async () => { 

 

})

</script>

 